export enum HARDWARE_ADAPTER_TYPES {
  BUTLER_V1 = "butler_v1",
}

export type HardwareAdapterType = `${HARDWARE_ADAPTER_TYPES}`;
